import type { Style, Workbook } from "exceljs";
import { installMaxWidth } from "tools/file/xlsx";

export type ExcelColumn = {
  header: string;
  key: string;
  style?: Partial<Style>;
};

export default async (
  data: (string | number)[][],
  fileName?: string,
  customColumn?: (ExcelColumn | string)[]
): Promise<void> => {
  const ExcelJS = await import("exceljs");

  const workbook = new ExcelJS.Workbook();
  const worksheetName = fileName
    ? fileName.replace(/[*?:\\/[\]]/g, "")
    : "sheet";
  const worksheet = workbook.addWorksheet(worksheetName);

  if (customColumn) {
    worksheet.columns = customColumn;
  }

  worksheet.addRows(data);
  installMaxWidth(worksheet);

  await downloadFromWorkbook(workbook, fileName);
};

export const downloadFromWorkbook = async (
  workbook: Workbook,
  fileName?: string
) => {
  const buffer = await workbook.xlsx
    .writeBuffer()
    .catch((e) => console.error("Error while writting data to xlsx: ", e));

  if (!buffer) {
    return;
  }

  const file = new Blob([buffer]);
  const blobUrl = URL.createObjectURL(file);

  const link = document.createElement("a");
  link.href = blobUrl;

  link.download = `${fileName || "File"}.xlsx`;

  document.body.appendChild(link);

  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  document.body.removeChild(link);
};
